package com.essntl.core.waypoint.di

import com.essntl.core.waypoint.data.WaypointClientImpl
import com.essntl.core.waypoint.domain.WaypointClient
import org.koin.dsl.module

val waypointModule
    get() =
        module {
            single<WaypointClient> { WaypointClientImpl(get()) }
        }
